// One source of truth for showing a lead's source. New pipeline leads store
// the SYSTEM lead source's doc id (same list Settings manages and deals use);
// legacy leads carry the old hardcoded keys ("referral", "zillow", …), which
// still display via SOURCE_LABELS.
import { SOURCE_LABELS } from "./listingLeadStages";

export function leadSourceLabel(value, systemSources) {
  if (!value) return "";
  const hit = (systemSources || []).find((s) => s && s.id === value);
  if (hit) return hit.name || "";
  return SOURCE_LABELS[value] || String(value);
}

// The system list as <select> options.
export function systemSourceOptions(systemSources) {
  return (systemSources || [])
    .filter((s) => s && s.id)
    .map((s) => ({ value: s.id, label: s.name || s.id }));
}

// Resolve a stored source value (system id or legacy key) to the full system
// lead-source OBJECT — the shape deals store in `deal.leadsource`. Falls back
// to matching by name for legacy string values; null when nothing matches.
export function resolveSystemSource(value, systemSources) {
  if (!value) return null;
  const list = systemSources || [];
  return (
    list.find((s) => s && s.id === value) ||
    list.find(
      (s) =>
        s &&
        typeof s.name === "string" &&
        s.name.toLowerCase() === String(value).toLowerCase(),
    ) ||
    null
  );
}
